import { useEffect } from 'react';
import { useActor } from '@xstate/react';

import { useIsLoggedIn } from '@order/AuthMachine';
import { useGlobalAppState } from '@order/GlobalAppState';

import { dietaryRestrictionsModel } from './dietaryRestrictionsMachine';

// ────────────────────────────────────────────────────────────────────────────────

export const useResetDietaryRestrictionsOnLogout = () => {
  const isLoggedIn = useIsLoggedIn();
  const { dietaryRestrictionsMachineRef } = useGlobalAppState();

  const [, send] = useActor(dietaryRestrictionsMachineRef);

  // ─────────────────────────────────────────────────────────────────

  useEffect(() => {
    return () => {
      if (!isLoggedIn) return;

      send(dietaryRestrictionsModel.events.CLEAR_RESTRICTIONS());
    };
  }, [isLoggedIn, send]);
};
